export default __webpack_public_path__ + "static/media/FranklinGothicURWCom-Dem.7237b8ca.ttf";